import { render, staticRenderFns } from "./ComponentRevenue.vue?vue&type=template&id=f5e49f02"
import script from "./ComponentRevenue.vue?vue&type=script&lang=js"
export * from "./ComponentRevenue.vue?vue&type=script&lang=js"
import style0 from "./ComponentRevenue.vue?vue&type=style&index=0&id=f5e49f02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports